<section class="page-container submitMemberNews">


    <div class="container">

        <h1>One-time Payment</h1>

        <p class="submitInstructions">
            Current Members Must Login to Pay Membership or Health Alliances Dues. If you have trouble logging in, please email <a href="mailto:portal@indychamber.com">portal&#64;indychamber.com</a>.
        </p>

        <div class="submitMemberNewsWrap mt-4">
            <form [formGroup]="paymentInfoForm" class="submitMemberNewsForm">
                <div class="row gx-5">
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-6 mb-4">
                                <label for="yourName" class="form-label">Your Name</label>
                                <input formControlName="yourName" type="text" class="form-control" id="yourName"
                                    placeholder="Your Name">
                                <div *ngIf="yourNameCtrl.invalid && (yourNameCtrl.dirty || yourNameCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is
                                    required.
                                </div>
                            </div>
                            <div class="col-md-6 mb-4">
                                <label for="yourCompanyName" class="form-label">Your Company Name</label>
                                <input formControlName="companyName" type="text" class="form-control"
                                    id="yourCompanyName" placeholder="Your Company Name">
                                <div
                                    *ngIf="companyNameCtrl.invalid && (companyNameCtrl.dirty || companyNameCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is
                                    required.
                                </div>
                            </div>
                            <div class="col-md-6 mb-4">
                                <label for="yourPhone" class="form-label">Your Phone Number</label>
                                <input mask="(000) 000-0000" placeholder="(123) 123-1234" formControlName="phoneNumber"
                                    type="text" class="form-control" id="yourPhone">
                                <div
                                    *ngIf="phoneNumberCtrl.invalid && (phoneNumberCtrl.dirty || phoneNumberCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is
                                    required.
                                </div>
                            </div>
                            <div class="col-md-6 mb-4">
                                <label for="yourEmail" class="form-label">Your Email</label>
                                <input formControlName="email" type="text" class="form-control" id="yourEmail"
                                    placeholder="Email">
                                <div *ngIf="emailCtrl.invalid && (emailCtrl.dirty || emailCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is
                                    required.
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 mb-4">
                                <label for="paymentReason" class="form-label">Payment Reason</label>
                                <select class="form-control" formControlName="paymentReason">
                                    <option *ngFor="let reason of paymentReasons" [ngValue]="reason.val">
                                        {{reason.title}}
                                    </option>
                                </select>
                                <div *ngIf="makingMembershipPaymentError()">
                                    <i class="fas fa-exclamation-circle"></i> You must pay an active invoice to pay
                                    membership dues. Please log in and navigate
                                    <a [routerLink]="['/admin-portal/member/invoice-management']">here</a>
                                </div>
                                <div
                                    *ngIf="paymentReasonCtrl.invalid && (paymentReasonCtrl.dirty || paymentReasonCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is
                                    required.
                                </div>
                            </div>
                            <div class="col-md-4 mb-4">
                                <label for="paymentAmount" class="form-label">Payment Amount</label>
                                <input formControlName="paymentAmount" type="number" min="0.00" step="0.01"
                                    class="form-control" id="paymentAmount" placeholder="0.00">
                                <div
                                    *ngIf="paymentAmountCtrl.invalid && (paymentAmountCtrl.dirty || paymentAmountCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is
                                    required.
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="paymentReason() != 7">
                            <div class="col-md-8 mb-4">
                                <label for="invoiceNumber" class="form-label">Invoice Number</label>
                                <input formControlName="invoiceNumber" type="text"
                                    class="form-control" id="invoiceNumber" placeholder="Invoice Number">
                                <div
                                    *ngIf="invoiceNumberCtrl.invalid && (invoiceNumberCtrl.dirty || invoiceNumberCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is
                                    required.
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-8 mb-4">
                                <label for="invoiceNumber" class="form-label">Memo</label>
                                <textarea  formControlName="memo" type="textarea"rows="3"
                                    class="form-control" id="memo" placeholder="Memo"></textarea>
                                <div
                                    *ngIf="invoiceNumberCtrl.invalid && (invoiceNumberCtrl.dirty || invoiceNumberCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is
                                    required.
                                </div>
                            </div>

                        </div>

                        <div class="bgPay p-4">
                            <div class="row">
                                <div class="col">
                                    <label for="paymentSelect" class="form-label d-block mb-2">Payment Options</label>
                                    <div class="btn-group paymentSelect mb-3" role="group" aria-label="Payment Type">
                                        <input [value]="1" [formControl]="paymentTypeCtrl" [checked]="1" type="radio"
                                            class="btn-check" name="btnPaymentSelect" id="btnPaymentSelect1"
                                            autocomplete="off">
                                        <label class="btn btn-outline-primary" for="btnPaymentSelect1">Credit
                                            Card</label>

                                        <!-- <input [value]="2" [formControl]="paymentTypeCtrl" [checked]="2" type="radio"
                                            class="btn-check" name="btnPaymentSelect" id="btnPaymentSelect2"
                                            autocomplete="off">
                                        <label class="btn btn-outline-primary" for="btnPaymentSelect2">eCheck</label> -->
                                    </div>
                                </div>
                                <div class="col-auto mb-3 text-end">
                                    <div class="fw-semibold text-primary fs-4 mb-1">
                                        Payment Method will be charged
                                    </div>
                                    <div class="fw-bold textPay fs-3">
                                        {{paymentAmount()| currency:'USD':'symbol'}}
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div class="row mt-3">
                                <div class="col-12 mb-3">
                                    <div class="paymentInputs">
                                        <!-- show if credit card, otherwise class hides -->
                                        <div *ngIf="paymentType() == 1">
                                            <div class="row">
                                                <div class="col-md-8 mb-3">
                                                    <label for="cardNo" class="form-label">Card Number</label>
                                                    <input formControlName="cardNumber" type="text" class="form-control"
                                                        id="cardNo" placeholder="Card Number" minlength="13"
                                                        maxlength="16">
                                                    <div
                                                        *ngIf="cardNumberCtrl.invalid && (cardNumberCtrl.dirty || cardNumberCtrl.touched)">
                                                        <i class="fas fa-exclamation-circle"></i> This field is
                                                        required.
                                                    </div>
                                                </div>
                                                <div class="col-md-2 mb-3">
                                                    <label for="cardExp" class="form-label">Expiration</label>
                                                    <input type="text" formControlName="cardExpiration"
                                                        class="form-control" id="cardExp" mask="00/00"
                                                        placeholder="MM/YY">
                                                    <div
                                                        *ngIf="cardExpirationCtrl.invalid && (cardExpirationCtrl.dirty || cardExpirationCtrl.touched)">
                                                        <i class="fas fa-exclamation-circle"></i> This field is
                                                        required.
                                                    </div>
                                                </div>
                                                <div class="col-md-2 mb-3">
                                                    <label for="cardCVV" class="form-label">CVV</label>
                                                    <input formControlName="cvv" type="text" class="form-control"
                                                        id="cardCVV" placeholder="CVV" minlength="3" maxlength="4">
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-8 mb-3">
                                                    <label for="yourAddress" class="form-label">Address</label>
                                                    <input type="text" formControlName="street" class="form-control"
                                                        id="yourAddress" placeholder="Address">
                                                    <div
                                                        *ngIf="streetCtrl.invalid && (streetCtrl.dirty || streetCtrl.touched)">
                                                        <i class="fas fa-exclamation-circle"></i> This field is
                                                        required.
                                                    </div>
                                                </div>
                                                <div class="col-md-4 mb-3">
                                                    <label for="yourAddress2" class="form-label">Apt/Suite <small
                                                            class="fst-italic fw-normal text-muted">(optional)</small></label>
                                                    <input type="text" formControlName="street2" class="form-control"
                                                        id="yourAddress2" placeholder="#">
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6 mb-3">
                                                    <label for="yourCity" class="form-label">City</label>
                                                    <input formControlName="city" type="text" class="form-control"
                                                        id="yourCity" placeholder="City">
                                                    <div
                                                        *ngIf="cityCtrl.invalid && (cityCtrl.dirty || cityCtrl.touched)">
                                                        <i class="fas fa-exclamation-circle"></i> This field is
                                                        required.
                                                    </div>
                                                </div>
                                                <div class="col-md-4 mb-3">
                                                    <label for="yourState" class="form-label">State</label>
                                                    <select formControlName="state" class="form-select"
                                                        aria-label="state">
                                                        <option selected>Select</option>
                                                        <option value="AL">Alabama</option>
                                                        <option value="AK">Alaska</option>
                                                        <option value="AZ">Arizona</option>
                                                        <option value="AR">Arkansas</option>
                                                        <option value="CA">California</option>
                                                        <option value="CO">Colorado</option>
                                                        <option value="CT">Connecticut</option>
                                                        <option value="DE">Delaware</option>
                                                        <option value="DC">District Of Columbia</option>
                                                        <option value="FL">Florida</option>
                                                        <option value="GA">Georgia</option>
                                                        <option value="HI">Hawaii</option>
                                                        <option value="ID">Idaho</option>
                                                        <option value="IL">Illinois</option>
                                                        <option value="IN">Indiana</option>
                                                        <option value="IA">Iowa</option>
                                                        <option value="KS">Kansas</option>
                                                        <option value="KY">Kentucky</option>
                                                        <option value="LA">Louisiana</option>
                                                        <option value="ME">Maine</option>
                                                        <option value="MD">Maryland</option>
                                                        <option value="MA">Massachusetts</option>
                                                        <option value="MI">Michigan</option>
                                                        <option value="MN">Minnesota</option>
                                                        <option value="MS">Mississippi</option>
                                                        <option value="MO">Missouri</option>
                                                        <option value="MT">Montana</option>
                                                        <option value="NE">Nebraska</option>
                                                        <option value="NV">Nevada</option>
                                                        <option value="NH">New Hampshire</option>
                                                        <option value="NJ">New Jersey</option>
                                                        <option value="NM">New Mexico</option>
                                                        <option value="NY">New York</option>
                                                        <option value="NC">North Carolina</option>
                                                        <option value="ND">North Dakota</option>
                                                        <option value="OH">Ohio</option>
                                                        <option value="OK">Oklahoma</option>
                                                        <option value="OR">Oregon</option>
                                                        <option value="PA">Pennsylvania</option>
                                                        <option value="RI">Rhode Island</option>
                                                        <option value="SC">South Carolina</option>
                                                        <option value="SD">South Dakota</option>
                                                        <option value="TN">Tennessee</option>
                                                        <option value="TX">Texas</option>
                                                        <option value="UT">Utah</option>
                                                        <option value="VT">Vermont</option>
                                                        <option value="VA">Virginia</option>
                                                        <option value="WA">Washington</option>
                                                        <option value="WV">West Virginia</option>
                                                        <option value="WI">Wisconsin</option>
                                                        <option value="WY">Wyoming</option>
                                                    </select>
                                                    <div
                                                        *ngIf="stateCtrl.invalid && (stateCtrl.dirty || stateCtrl.touched)">
                                                        <i class="fas fa-exclamation-circle"></i> This field is
                                                        required.
                                                    </div>
                                                </div>
                                                <div class="col-md-2 mb-3">
                                                    <label for="yourZip" class="form-label">ZIP</label>
                                                    <input formControlName="zip" type="text" class="form-control"
                                                        id="yourZip" placeholder="ZIP">
                                                    <div *ngIf="zipCtrl.invalid && (zipCtrl.dirty || zipCtrl.touched)">
                                                        <i class="fas fa-exclamation-circle"></i> This field is
                                                        required.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- show if ach, otherwise class d-none hides -->
                                        <div *ngIf="paymentType() == 2" class="row">
                                            <div class="col-lg-6 mb-3">
                                                <div class="eCheckImg">
                                                    <img class="w-100 rounded" src="../../../assets/images/echeck.jpg"
                                                        alt="echeck" />
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="paymentType() == 2" class="row align-items-end">
                                            <div class="col-lg-6 mb-3">
                                                <label for="accountName" class="form-label">Name on Account</label>
                                                <input formControlName="accountName" type="text" class="form-control"
                                                    id="accountName" placeholder="Name on Account">
                                                <div
                                                    *ngIf="accountNameCtrl.invalid && (accountNameCtrl.dirty || accountNameCtrl.touched)">
                                                    <i class="fas fa-exclamation-circle"></i> This field is
                                                    required.
                                                </div>
                                            </div>
                                            <div class="col-lg-6 mb-3">
                                                <label for="routingNo" class="form-label">Routing Number</label>
                                                <input formControlName="routingNumber" type="text" class="form-control"
                                                    id="cardNo" placeholder="Routing Number">
                                                <div
                                                    *ngIf="routingNumberCtrl.invalid && (routingNumberCtrl.dirty || routingNumberCtrl.touched)">
                                                    <i class="fas fa-exclamation-circle"></i> This field is required
                                                    and must be 9 digits.
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-3">
                                                <label for="accountNo" class="form-label">Account Number</label>
                                                <input formControlName="accountNumber1" type="text" class="form-control"
                                                    id="accNumber1" placeholder="Account Number" minlength="5"
                                                    maxlength="17">
                                                <div
                                                    *ngIf="accountNumber1Ctrl.invalid && (accountNumber1Ctrl.dirty || accountNumber1Ctrl.touched)">
                                                    <i class="fas fa-exclamation-circle"></i> This field is
                                                    required.
                                                </div>
                                                <div *ngIf="accountNumbersMatchError">
                                                    <i class="fas fa-exclamation-circle"></i> Account numbers do not
                                                    match.
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-3">
                                                <label for="accountNo2" class="form-label">Confirm Account
                                                    Number</label>
                                                <input formControlName="accountNumber2" type="text" class="form-control"
                                                    id="accNumber2" placeholder="Confirm Account Number" minlength="5"
                                                    maxlength="17">
                                                <div
                                                    *ngIf="accountNumber2Ctrl.invalid && (accountNumber2Ctrl.dirty || accountNumber2Ctrl.touched)">
                                                    <i class="fas fa-exclamation-circle"></i> This field is
                                                    required.
                                                </div>
                                                <div *ngIf="accountNumbersMatchError">
                                                    <i class="fas fa-exclamation-circle"></i> Account numbers do not
                                                    match.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-md-4  border-start border-light">
                        <div class="mb-4">
                            <div class="fw-semibold text-primary fs-3 mb-2">
                                Lorem ipsum non account account
                            </div>
                            <p class="m-0">
                                Lucas ipsum dolor sit amet moff skywalker ponda calamari amidala moff luke anakin
                                tatooine antilles. Amidala skywalker calrissian gonk lars chewbacca. Luuke calamari
                                darth han calrissian ben sebulba. Han baba darth greedo kessel dantooine coruscant.
                                Skywalker darth mothma organa greedo. Ventress solo jade k-3po leia. Moff organa solo
                                darth sidious amidala endor padmé. Darth padmé skywalker organa kenobi anakin fett watto
                                skywalker. Biggs ben darth organa darth aayla darth. Windu wookiee darth mara owen.
                            </p>
                        </div>
                        <div class="mb-4">
                            <label for="password1" class="form-label">Password (optional)</label>
                            <input formControlName="password1" type="text" class="form-control" id="password1"
                                placeholder="Password">
                            <password-strength-meter [password]="pass1" [enableFeedback]="true"
                                (strengthChange)="strengthChanged($event)" />
                        </div>
                        <div class="mb-4">
                            <label for="password2" class="form-label">Confirm Password</label>
                            <input formControlName="password2" type="text" class="form-control" id="password2"
                                placeholder="Confirm Password">
                        </div>
                        <div *ngIf="showPasswordErrors" class="mb-4">
                            <div *ngIf="tooShort()" class="alert alert-danger">
                                Password must be at least 8 characters.
                            </div>
                            <div *ngIf="passwordMismatch()" class="alert alert-danger">
                                Passwords must match.
                            </div>
                            <div *ngIf="lowStrength()" class="alert alert-danger">
                                Password must be at least strength 3
                            </div>
                        </div>
                    </div> -->
                    <div class="col-12 text-center mt-4">
                        <button [disabled]="makingMembershipPaymentError()" (click)="submitPayment()" type="button"
                            class="btn btn-secondary m-100 newsSubmitBtn">Submit Payment</button>
                    </div>
                </div>
            </form>
        </div>

    </div>

</section>